import { LightningElement, track, api } from 'lwc';



export default class sldsRadioGroup extends LightningElement {
    static renderMode = 'light';
    @track errorMessage;
    @track isError = false
    @track currentValue;
    
    @api label = '';
    @api isRequired = false;

    @track _options;
    @api 
    set options(val) {
        this._options = val;
        if (val) {
            this.currentValue = val[0].value;
        }
    } 
    get options() {
        return this._options;
    }

    // Return the current selection
    @api getSelection() {
        // Get the input elements from the radio group
        const radioInputs = this.querySelectorAll('[data-element="radio"]');

        let selected = null;

        if (radioInputs) {
            // Find the selected radio
            selected  = Array.from(radioInputs).find(radio => radio.checked).value;
        } 

        return selected;
    }
    @api sendValues() {
        // Get the input elements from the radio group
        const radioInputs = this.querySelectorAll('[data-element="radio"]');

        let selected = null;

        if (radioInputs) {
            // Find the selected radio
            selected  = Array.from(radioInputs).find(radio => radio.checked).value;
        } 

        return selected;
    }
    // Trigger error
    @api errorMe(errorMessage) {
        this.errorMessage = errorMessage;
        this.handleErrorAttributes();
    }
    // Focus the first radio
    @api focusMe() {
        const radios = this.querySelectorAll('[data-element="radio"]');
        radios[0].focus();
    }

    // Detect when the selected radio changes
    handleChange(event) {
        if (event.target.checked) {
            this.currentValue = event.target.value;
        }

        if (this.currentValue && this.isError) {
            // Remove the errors
            this.handleErrorAttributes(true);
        }

        if (this.currentValue) {
            this.dispatchEvent(new CustomEvent('newinput', { detail: {value: this.currentValue} } ));
        }
    } 

    // isRemove=false: Add name="error" && aria-describedby="error_01"  --> isRemove=true: remove the attributes
    handleErrorAttributes(isRemove=false) {
        // Get the radio groups
        const radioInputs = this.querySelectorAll('[data-element="radio"]');

        if (!radioInputs) return;

        // Set the error flag to the opposite of <isRemove> (false if true) 
        this.isError = !isRemove;

        if (isRemove) {
            // Reset <errorMessage>
            this.errorMessage = '';
            
            // Remove the  error attributes
            radioInputs.forEach(radio => {
                radio.setAttribute("name", "radioGroup");   // Return to the original name attribute
                radio.removeAttribute("aria-describedby"); // remove aria-describedby
            });
            return;
        }

        // Add the error attributes
        radioInputs.forEach(radio => {
            radio.setAttribute("name", "error");
            radio.setAttribute("aria-describedby", "error_01");
        });
    }

}